import { styled, keyframes } from '@mui/material/styles';
import { palette } from 'view/themes/palette';

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const SpinnerWrapper = styled('div')({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
});

export const SpinnerSvg = styled('svg')<{ disabled: boolean }>(({ disabled }) => {
  return {
    animation: `${rotate} 5s linear infinite`,

    '&.outlined': {
      fill: disabled ? palette.unknown.disabled_grey : palette.primary.purple500,
    },

    '&.contained': {
      fill: palette.white,
    },
  };
});
